export const URL_Links = (`${process.env.REACT_APP_HOST}/link`);
export const URL_LinkClinic = (`${process.env.REACT_APP_HOST}/linkClinic`);
